export default __webpack_public_path__ + "static/media/empty-group.028c0645.svg";